import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="card">
      <h2 className="card__title">Page not found</h2>
      <p style={{ color: 'var(--text-muted)' }}>
        That page does not exist, or is not available for your role.
      </p>
      <Link to="/">Back to the dashboard</Link>
    </div>
  );
}
